import { CLEARED_FILTERS_COOKIE_NAME, setCookie } from '@fiverr-private/listing_lib';

export const setClearedFiltersCookie = () =>
    setCookie({
        name: CLEARED_FILTERS_COOKIE_NAME,
        value: true,
        expirationDays: 1,
        domain: null,
    });
